import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Logo from 'components/atoms/Logo'
import FormResult from 'components/organisms/FormResult'
import LinkButton from 'components/atoms/buttons/LinkButton'

const styles = theme => ({
  root: {
    maxWidth: 350,
    display: 'flex',
    margin: '0 auto',
    minHeight: '100vh',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      maxWidth: 450,
    },
  },
  content: {
    textAlign: 'center',
  },
  logo: {
    marginBottom: theme.spacing(6),
  },
  loginLink: {
    height: 50,
    width: 175,
    display: 'none',
    margin: '0 auto',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
})

const TrapInviteVerify = ({ classes }) => (
  <div className={classes.root}>
    <Logo className={classes.logo} />
    <div className={classes.content}>
      <FormResult
        hideButton
        heading="Sweet as! You've accepted the invitation"
        subHeading="You can now login with your chirp account and have admin access to this project"
      />
      <LinkButton
        width={200}
        size="large"
        color="primary"
        variant="primary"
        to="/account/home"
        label="Go to dashboard"
        className={classes.loginLink}
      />
    </div>
  </div>
)

TrapInviteVerify.propTypes = {
  classes: PropTypes.object,
}

export default withStyles(styles)(TrapInviteVerify)



// WEBPACK FOOTER //
// ./src/components/organisms/AdminInviteSuccess.js